
import { Vue } from 'vue-class-component';

export default class PageLoading extends Vue {}
